import { CommonModule, DOCUMENT } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, Component, Inject, OnDestroy, inject } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { DomSanitizer } from "@angular/platform-browser";
import { Meta } from "@angular/platform-browser";
import { Router } from "@angular/router";
import { IonicModule } from "@ionic/angular";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { Subject, of, switchMap, takeUntil } from "rxjs";

import { LicenseTypes } from "@models/MasterData";
// MODELS
import { GlobalVarsModel } from "@models/ModelGlobalsVar";

// ROUTES
import { SPORTS_PATHS } from "@shared-constants/routes";

import { NewBaseService } from "@providers/newBase.service";
// SERVICES
import { DeviceService } from "@services/device.service";

@Component({
  selector: "betbuilder-page",
  templateUrl: "betbuilder.page.html",
  styleUrls: ["betbuilder.page.scss"],
  host: {
    class: "betbuilder",
  },
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  standalone: true,
  imports: [IonicModule, CommonModule, FormsModule, TranslateModule],
})
export class CreaTuApuestaPage implements OnDestroy {
  globalVars: GlobalVarsModel;
  router = inject(Router);
  deviceService = inject(DeviceService);
  newBaseService = inject(NewBaseService);
  metaService = inject(Meta);
  translate = inject(TranslateService);
  videoUrl: any;
  isMobile: boolean = false;

  private readonly unsubscribe$ = new Subject();

  constructor(
    @Inject(DOCUMENT) private dom: Document,
    public sanitizer: DomSanitizer,
  ) {
    this.isMobile = this.deviceService.isMobile();

    this.newBaseService.getVars
      .pipe(
        switchMap((data: GlobalVarsModel) => {
          this.globalVars = data;
          return of(null);
        }),
      )
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe();

    this.updateCanonicalUrl();

    this.metaService.addTag({ name: "title", content: this.translate.instant("SPO_BetbuilderMetaTitle") });
    this.metaService.updateTag({
      name: "description",
      content: this.translate.instant(this.translate.instant("SPO_BetbuilderMetaDescription")),
    });

    this.getBetbuilderVideo();
  }

  private updateCanonicalUrl() {
    const head = this.dom.getElementsByTagName("head")[0];
    const existingCanonicalLink = this.dom.querySelector('link[rel="canonical"]');
    let canonicalLink: HTMLLinkElement;

    if (!existingCanonicalLink) {
      canonicalLink = this.dom.createElement("link") as HTMLLinkElement;
      canonicalLink.rel = "canonical";
      head.appendChild(canonicalLink);
    } else {
      canonicalLink = existingCanonicalLink as HTMLLinkElement;
    }
    canonicalLink.href = this.translate.instant("SPO_BetbuilderCanonicalURL");
  }

  navigateToGame() {
    const item = { Name: "Fútbol", NodeId: "358476322", SportHandle: "soccer" };
    this.router.navigate([SPORTS_PATHS.SportCountriesPage], { state: { params: item } });
  }

  getBanner(): string {
    let license = "ES";
    const device = this.isMobile ? "mobile" : "desktop";
    switch (this.globalVars.licenseType) {
      case LicenseTypes.ArgentinaPBA:
      case LicenseTypes.ArgentinaCaba:
        license = "AR";
        break;
      case LicenseTypes.Mexico:
        license = "MX";
        break;
      case LicenseTypes.Colombia:
        license = "CO";
        break;
      case LicenseTypes.Panama:
        license = "PA";
        break;
      case LicenseTypes.Madrid:
      case LicenseTypes.Nacional:
      default:
        license = "ES";
        break;
    }
    const banner = `assets/global/img/betbuilder/banner-${device}-${license}.jpg`;
    return banner;
  }

  getBetbuilderVideo() {
    switch (this.globalVars.licenseType) {
      case LicenseTypes.ArgentinaPBA:
      case LicenseTypes.ArgentinaCaba:
        this.videoUrl = "https://www.codere.bet.ar/betbuilder/video.mp4";
        break;
      case LicenseTypes.Colombia:
        this.videoUrl = "https://www.codere.com.co/betbuilder/video.mp4";
        break;
      case LicenseTypes.Panama:
        this.videoUrl = "https://www.codere.pa/betbuilder/video.mp4";
        break;
      case LicenseTypes.Madrid:
      case LicenseTypes.Nacional:
      default:
        this.videoUrl = "https://www.codere.es/betbuilder1/video.mp4";
        break;
    }
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(null);
    this.unsubscribe$.complete();
  }
}
